import {z} from 'zod';

import {head} from 'ramda';

import {ApiError} from 'shared/web';

const ApiErrorBodySchema = z.object({
  errors: z.array(z.object({code: z.string()})),
});

/** First backend error code of a failed request, or null when the body has no code list. */
export const getTelephonyCallApiErrorCode = (error: ApiError) => {
  if (!('data' in error)) {
    return null;
  }

  const parsed = ApiErrorBodySchema.safeParse(error.data);

  return parsed.success ? (head(parsed.data.errors)?.code ?? null) : null;
};
